<template>
  <div class="number-info-content write-info-content">
    <div class="number-info-input">
      <span class="write-info-title">企业单位名称：</span>
      <a-input
        size="large"
        placeholder="请填写企业单位名称"
        v-model="info.companyName"
      />
      <!--      <v-select-company-->
      <!--        size="large"-->
      <!--        placeholder="请填写企业单位名称"-->
      <!--        @change="chooseCompany"-->
      <!--      />-->
      <!-- <a-select
          size="large"
          show-search
          placeholder="请填写企业单位名称："
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option value="3"> 3 </a-select-option>
          <a-select-option value="32223"> 32223 </a-select-option>
        </a-select> -->
    </div>
    <!--    <div class="enterprise-info" v-if="!!tianyanData">-->
    <!--      <p>-->
    <!--        <a-icon type="info-circle" theme="filled" />-->
    <!--        企业信息数据来源于天眼查-->
    <!--      </p>-->
    <!--      <div>-->
    <!--        <div>-->
    <!--          <span>法定代表人</span>-->
    <!--          <p>{{ tianyanData.legalPersonName }}</p>-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <span>经营状态</span>-->
    <!--          <p>{{ tianyanData.regStatus }}</p>-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <span>成立日期</span>-->
    <!--          <p>{{ tianyanData.estiblishTime | moment("YYYY-MM-DD") }}</p>-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <span>注册资本</span>-->
    <!--          <p>{{ tianyanData.regCapital }}</p>-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <span>企业规模</span>-->
    <!--          <p>{{ tianyanData.staffNumRange }}</p>-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <span>所属行业</span>-->
    <!--          <p>{{ tianyanData.industry }}</p>-->
    <!--        </div>-->
    <!--        <div style="width: 100%">-->
    <!--          <span>统一社会信用代码</span>-->
    <!--          <p>{{ tianyanData.regNumber }}</p>-->
    <!--        </div>-->
    <!--        <div style="width: 100%">-->
    <!--          <span>经营范围</span>-->
    <!--          <p>-->
    <!--            {{ tianyanData.businessScope }}-->
    <!--          </p>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="number-info-input">
      <span class="write-info-title">统一社会信用代码：</span>
      <a-input
        size="large"
        placeholder="请填写统一社会信用代码"
        v-model="info.socialCreditCode"
      />
    </div>
    <div class="number-info-input">
      <span class="write-info-title">企业联系人：</span>
      <a-input
        size="large"
        placeholder="请填写企业联系人姓名"
        v-model="info.contactPerson"
      />
    </div>
    <div class="number-info-input">
      <span class="write-info-title">联系电话：</span>
      <a-input size="large" v-model="info.contactPhone" />
    </div>
  </div>
</template>

<script>
import { registerSupplementInfo, registerSupplementInfo2 } from "@/api/login";

export default {
  name: "EnpInfo",
  data() {
    return {
      // tianyanData: null,
      info: {},
    };
  },
  methods: {
    // chooseCompany(company) {
    //   this.info.code = company.regNumber;
    //   this.info.name = company.name;
    //   this.info.buid = company.id;
    //   getCompanyInfo(company.id).then((res) => {
    //     this.tianyanData = res.data;
    //   });
    // },
    submit() {
      let info = this.info;
      if (!info.companyName) {
        this.$message.warning("请填写企业组织名称");
      }
      if (!info.socialCreditCode) {
        this.$message.warning("请填写统一社会信用代码");
        return;
      }
      if (!info.contactPerson) {
        this.$message.warning("请填写组织联系人");
        return;
      }
      if (!info.contactPhone) {
        this.$message.warning("请填写联系电话");
        return;
      }
      const data = {
        companyName: info.companyName,
        englishName: "",
        socialCreditCode: info.socialCreditCode,
        industry: "",
        regAddress: "",
        userId: "",
        status: "",
        introduction: "",
        regCapitalUnit: "",
        validCertId: null,
        applyTime: null,
        auditReason: null,
        companyType: "2",
        contactPerson: info.contactPerson,
        contactPhone: info.contactPhone,
      };
      registerSupplementInfo2(data).then((res) => {
        this.$store.dispatch("GetInfo");
        this.$emit("success", res.data);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.number-info-content {
  height: 510px;
  padding-top: 40px;

  .number-info-input {
    display: flex;
    margin-bottom: 32px;
    justify-content: space-between;

    .write-info-title {
      width: 130px;
      text-align: right;
      line-height: 40px;
    }

    > div {
      flex: 1;

      .write-info-radio {
        height: 40px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }

      .write-info-no-code {
        > textarea {
          height: 80px;
          margin-bottom: 16px;
        }

        .write-upload-list {
          margin-top: 16px;

          > div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 32px;
            padding: 0 16px;
            background: #f5f5f5;

            > p {
              display: flex;
              align-items: center;
              max-width: 80%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              > img {
                margin-right: 16px;
              }
            }

            > span {
              color: #1abc9c;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .enterprise-info {
    padding-left: 34px;
    margin-bottom: 24px;

    > p {
      font-size: 14px;
      color: #8c8c8c;
      display: flex;
      align-items: center;
      line-height: 14px;
      margin-bottom: 16px;

      > i {
        color: #faad14;
        margin-right: 8px;
      }
    }

    > div {
      display: flex;
      flex-wrap: wrap;
      border-top: 1px solid #f0f0f0;
      border-left: 1px solid #f0f0f0;

      > div {
        width: 50%;
        display: flex;

        > span {
          width: 120px;
          line-height: 32px;
          background: #ebf9f6;
          border-right: 1px solid #f0f0f0;
          border-bottom: 1px solid #f0f0f0;
          padding-left: 10px;
          color: #8c8c8c;
          font-size: 12px;
        }

        > p {
          flex: 1;
          padding: 0 10px;
          border-right: 1px solid #f0f0f0;
          border-bottom: 1px solid #f0f0f0;
          font-size: 12px;
          height: 32px;
          line-height: 32px;
        }

        &:last-child {
          > p {
            height: 72px;
            line-height: 22px;
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>
